import { request } from "../http/http"
import EntityService from "./entity";

class CategoryService extends EntityService {
  constructor(name) {
    super(name)
  }

  async getEntityPage(entities, pageable) {
    const result = await request({
      url: `/exhibit-categories`,
      method: "get",
      params: {
        ...entities,
        ...pageable,
      },
    });

    return result;
  }
}

export default new CategoryService("exhibit-category")



// WEBPACK FOOTER //
// ./src/services/category.js